

export type EntityTypeOption = "city" | "POI" | "TripPOI";

export const EntityTypeMap: Record<EntityTypeOption, number> = {
  city: 1,
  POI: 2,
  TripPOI: 3,
};